module.exports = __webpack_public_path__ + "img/unsupported-countries.86bb4005.png";